import styled     from '@emotion/styled';
import { Button } from 'components/ui';

import ProgressModal          from "./UploadPrograssModal";
import { useState }            from 'react';
import ReactGA  from "react-ga4";


const Elem:React.FC<any> = ({ showModal, closeModal }) =>{
  const [ showProgressModel, setShowProgressModal ] = useState(false);
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  const handleGotoPrograss = async (event:any) => {
    setShowProgressModal(true);
    if (gaId)
    ReactGA.event({
      "category": "Modal",
      "action" : "Open",
      "label" : "free photo prograss modal",
      "value": 1
    });
  };

  return (
    <>
      {showModal?
        <Background onClick={closeModal}>
          <ModalContainer onClick={e => e.stopPropagation()}>
            <TextConatinser>
              <BoldText className="top">무료 체험은</BoldText>
              <BoldText className="bottom">전송 후 변경할 수 없어요</BoldText>
              <SmallText>선택한 사진을 전송하시겠어요?</SmallText>
            </TextConatinser>
            <ButtonContainer>
              <ButtonWrapper>
                <Button 
                  layoutVariant="contained"
                  variant="default"
                  onClick={closeModal}
                  expand
                  >다시 선택</Button>
              </ButtonWrapper>
              <ButtonWrapper>
                <Button 
                  layoutVariant="contained"
                  variant="default"
                  onClick={handleGotoPrograss}
                  expand
                  >확정 후 전송
                </Button>
              </ButtonWrapper>
            </ButtonContainer>
          </ModalContainer>
        </Background>:null }
      {showProgressModel && <ProgressModal />}
    </>
  )
};

export default Elem;

const Background = styled.div`
  position:fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0,0,0,0.50);
  z-index: 0;
`;
const ModalContainer = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-height: 80%;
  width: 343px;
  height: 231px;
  background-color: white;
  text-align: center;
  display:flex;
  flex-direction: column;
  padding-left: 24px;
`;
const TextConatinser = styled.div`
  width: 232px;
  height: 93px;
  margin-top: 42px;
  margin-left: 32px;
  display: flex;
  flex-direction: column;
`
const BoldText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 133%;
  
  color: #000000;

  &.top {
    /* margin-right: auto; */
  }

  &.bottom {
    /* margin-right: auto; */
    margin-top: 3px;
  }
`
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 133%;
  color: #000000;
  /* margin-right: auto; */
  margin-top: 9px;
`
const ButtonContainer = styled.div`
  width: 295.01px;
  height: 47px;
  margin-top: 39px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const ButtonWrapper = styled.div`
  height: 100%;
  width: 140.06px;
`